export default __webpack_public_path__ + "static/media/1773.7ebf1c58.png";